import React, { FC, useEffect, useState } from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  MenuItem,
  FormControl,
  Typography,
  Select,
  Button,
} from "@mui/material";

import styles from "../Profile.module.scss";
import { ArrowBack } from "@mui/icons-material";
import Layout from "../../../common/layouts/Layout";
import Navbar from "../../../common/Navbar/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { useUpdateUserMutation } from "../../../../generated/graphql";
import useAuthStore from "../../../../states/zustand/authStore";
import { RoutingList } from "../../../../constants";
import useAppStore from "../../../../states/zustand/appStore";

const ProfileEdit: FC = (): JSX.Element => {
  const navigate = useNavigate();
  const {
    state: { data },
  } = useLocation();

  const {
    profileData: { _id },
  } = useAuthStore();
  const [updateUserMutation, { loading }] = useUpdateUserMutation();

  const {setLoader} = useAppStore();

  useEffect(()=>{
    setLoader(loading)
  },[loading])

  const [name, setName] = useState<any>(data?.getUserById.name);
  const [email, setEmail] = useState<any>(data?.getUserById.email);
  const updateUser = async () => {
    try {
      await updateUserMutation({
        variables: {
          id: _id,
          name: name,
          email: email,
        },
      });
      navigate(RoutingList.profile.index.path);
    } catch (error) {
    }
  };

  return (
    <Layout>
      <>
        <Navbar pageTitle={"Profile Edit"} data={data} />
        <Container maxWidth={false}>
          <Box className={styles.profilePage}>
            <Grid container sx={{ justifyContent: "center" }}>
              <Grid item xs={12} md={8}>
                <Box className={styles.mb20}>
                  <Box className="d-flex align-items-center justify-content-between">
                    <Typography
                      variant="h2"
                      component="h2"
                      className={styles.headingH2}
                    >
                      Profile Info
                    </Typography>
                    <Typography color="error">*required fields</Typography>
                  </Box>
                  <Divider />
                </Box>
                <div className="form-group">
                  <label className="mb-1 form-label">Full name*</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name"
                    placeholder="Abc"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                {/* <div className="form-group">
                  <label className="mb-1 form-label">Birthday</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="name"
                    placeholder="Aug 08, 1994"
                  />
                </div> */}
                {/* <div className="form-group">
                  <label className="mb-1 form-label">Gender</label>
                  <div>
                    <FormControl className={styles.dropdown} variant="standard">
                      <Select
                        labelId="demo-customized-select-label"
                        id="demo-customized-select"
                        value={gender}
                        className={`form-control form-control-sm ${styles.dropdownInput}`}
                        onChange={handleChange}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={1}>Male</MenuItem>
                        <MenuItem value={2}>Female</MenuItem>
                        <MenuItem value={3}>Transgender</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div> */}
                <div className="form-group">
                  <label className="mb-1 form-label">Contact email*</label>
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    name="email"
                    placeholder="email@web.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                {/* <div className="form-group">
                  <label className="mb-1 form-label">Contact phone</label>
                  <input
                    type="tel"
                    className="form-control form-control-sm"
                    name="tel"
                    placeholder="+91 ### ### ####"
                  />
                </div> */}
              </Grid>
            </Grid>
            <Box className="d-flex justify-content-center align-items-center mg-t-60">
              <Button
                variant={"outlined"}
                color={"error"}
                className="mg-r-10"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                variant={"outlined"}
                color={"error"}
                className="mg-r-10"
                type="button"
                onClick={() => navigate(-1)}
              >
                <ArrowBack
                  className="mg-r-6"
                  sx={{ width: "1rem", height: "1rem" }}
                />
                <span>Back</span>
              </Button>
              <Button
                onClick={updateUser}
                variant={"contained"}
                color={"error"}
                type="submit"
              >
                Save
              </Button>
            </Box>
          </Box>
        </Container>
      </>
    </Layout>
  );
};

export default ProfileEdit;
